import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// f: {key, label, type: text|number|date|time|select|textarea, options:[string|{value,label}], span, placeholder, readOnly}
export function Field({ f, value, onChange, testPrefix = "field" }) {
  const id = `${testPrefix}-${f.key.replace(/_/g, "-")}`;
  const opts = (f.options || []).map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  let control;
  if (f.type === "select") {
    control = (
      <Select value={value ? String(value) : ""} onValueChange={(v) => onChange(f.key, v)} disabled={f.readOnly}>
        <SelectTrigger data-testid={id} className="h-11 sm:h-10">
          <SelectValue placeholder={f.placeholder || "Select"} />
        </SelectTrigger>
        <SelectContent className="bg-popover">
          {opts.map((o) => (
            <SelectItem key={o.value} value={String(o.value)}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  } else if (f.type === "textarea") {
    control = (
      <Textarea id={id} data-testid={id} rows={f.rows || 3} value={value ?? ""} placeholder={f.placeholder}
        onChange={(e) => onChange(f.key, e.target.value)} />
    );
  } else {
    control = (
      <Input
        id={id}
        data-testid={id}
        type={f.type || "text"}
        step={f.type === "number" ? "any" : undefined}
        inputMode={f.type === "number" ? "decimal" : undefined}
        value={value ?? ""}
        placeholder={f.placeholder}
        readOnly={f.readOnly}
        className={`h-11 sm:h-10 text-base sm:text-sm ${f.type === "number" ? "num" : ""}`}
        onChange={(e) => onChange(f.key, e.target.value)}
      />
    );
  }
  return (
    <div className={`space-y-1.5 min-w-0 ${f.span === 2 ? "sm:col-span-2" : f.span === 3 ? "sm:col-span-2 lg:col-span-3" : ""}`}>
      <Label htmlFor={id} className="text-xs font-semibold text-muted-foreground">
        {f.label}
        {f.required && <span className="text-rose-500"> *</span>}
      </Label>
      {control}
    </div>
  );
}

export function FieldGrid({ fields, data, onChange, cols = 3, testPrefix }) {
  const c = cols === 2 ? "sm:grid-cols-2" : cols === 4 ? "sm:grid-cols-2 lg:grid-cols-4" : "sm:grid-cols-2 lg:grid-cols-3";
  return (
    <div className={`grid grid-cols-1 ${c} gap-4`}>
      {fields.map((f) => (
        <Field key={f.key} f={f} value={data[f.key]} onChange={onChange} testPrefix={testPrefix} />
      ))}
    </div>
  );
}
